import { useEffect, useState } from 'react';
import { LiquidMetal } from '@paper-design/shaders-react';

const MESSAGES = [
  'Анализирую задачу...',
  'Проектирую архитектуру...',
  'Подбираю агентов...',
  'Настраиваю инструменты...',
  'Выстраиваю цепочку...',
  'Связываю сервисы...',
  'Проверяю логику...',
  'Финальная сборка...',
];

const wrapStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '56px 24px',
  gap: '24px',
  textAlign: 'center',
};

const canvasWrap = (scale: number): React.CSSProperties => ({
  transform: `scale(${scale})`,
  transition: 'transform 30ms linear',
  borderRadius: '50%',
  overflow: 'hidden',
  lineHeight: '0',
  display: 'block',
  border: '0',
  outline: 'none',
  boxShadow: '0 0 40px rgba(91,140,255,0.25)',
});

const msgStyle = (visible: boolean): React.CSSProperties => ({
  fontSize: '15px',
  fontWeight: 500,
  color: '#f1f1f5',
  minHeight: '22px',
  transition: 'opacity 0.35s ease',
  opacity: visible ? 1 : 0,
});

const hintStyle: React.CSSProperties = {
  fontSize: '12px',
  color: '#8b8b9e',
  maxWidth: '240px',
  lineHeight: 1.5,
};

export function LiquidLoader({ label }: { label?: string }) {
  const [msgIndex, setMsgIndex] = useState(0);
  const [visible, setVisible] = useState(true);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const rotateMsg = () => {
      setVisible(false);
      setTimeout(() => {
        setMsgIndex((i) => (i + 1) % MESSAGES.length);
        setVisible(true);
      }, 380);
    };
    const id = setInterval(rotateMsg, 2600);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    let t = 0;
    const id = setInterval(() => {
      t += 1;
      setScale(1 + 0.06 * Math.sin((t * Math.PI) / 80));
    }, 30);
    return () => clearInterval(id);
  }, []);

  return (
    <div style={wrapStyle}>
      <div style={canvasWrap(scale)}>
        <LiquidMetal
          width={120}
          height={120}
          shape="circle"
          colorBack="#0e0e12"
          colorTint="#5b8cff"
          repetition={3}
          softness={0.55}
          shiftRed={0.18}
          shiftBlue={0.22}
          distortion={0.12}
          contour={0.5}
          angle={45}
          speed={0.6}
          scale={0.9}
        />
      </div>
      <div style={msgStyle(visible)}>
        {label ?? MESSAGES[msgIndex]}
      </div>
      <div style={hintStyle}>
        Сложные сценарии собираются до 5 минут — не закрывайте экран
      </div>
    </div>
  );
}
